import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { QUIZZES } from '../../data/quizzes';

/**
 * @param {{ prenom: string, nbDone: number, quizDone: boolean[] }} props
 */
export default function TivQuestionnaires({ prenom, nbDone, quizDone }) {
  const navigate = useNavigate();
  const nextQuizIndex = quizDone.findIndex(d => !d);
  const nextQuiz = QUIZZES[nextQuizIndex] ?? QUIZZES[0];

  const remainingLabel =
    nbDone === 0 ? '4 questionnaires à faire'
    : nbDone === 3 ? "Plus qu'un questionnaire"
    : `Encore ${4 - nbDone} questionnaires`;

  return (
    <div className="flex flex-col gap-4">
      <div className="text-center mb-2">
        <p className="text-base font-semibold text-white">
          Salut {prenom || 'toi'}, moi c'est Tiv.
        </p>
        <p className="text-sm text-zinc-400 mt-1 leading-relaxed">
          Pour t'aider à écrire tes lettres Parcoursup, j'ai besoin de te connaître un peu mieux.
        </p>
      </div>

      <div className="bg-white/[0.03] border border-white/[0.06] rounded-2xl p-4">
        <div className="flex justify-between items-center mb-3">
          <span className="text-xs text-zinc-400">{remainingLabel}</span>
          <span className="text-xs font-bold text-emerald-400">{nbDone}/4</span>
        </div>
        <div className="flex gap-2">
          {QUIZZES.map((q, i) => (
            <div key={q.id} className="flex-1 text-center">
              <div
                className={`h-1 rounded-full mb-1.5 transition-all ${quizDone[i] ? 'bg-emerald-400' : 'bg-zinc-600'}`}
              />
              <span className={`text-[10px] font-semibold ${quizDone[i] ? 'text-emerald-400' : 'text-zinc-600'}`}>
                {q.label}
              </span>
            </div>
          ))}
        </div>
      </div>

      <button
        onClick={() => navigate(nextQuiz.path)}
        className="w-full flex items-center justify-center gap-2 py-4 bg-violet-600 hover:bg-violet-500 transition-colors rounded-2xl text-white text-sm font-bold"
      >
        Faire le questionnaire {nextQuiz.label} (~5 min)
        <ArrowRight size={16} />
      </button>
    </div>
  );
}
